import React from 'react'
import { useTranslation } from 'react-i18next'
import * as S from './SectionAppBioAtlas.styles'
import ImageNext from '@/components/ImageNext'

const SectionAppBioAtlas = () => {
  const { t } = useTranslation()

  return (
    <S.Section>
      <S.Container className="mw-unsigned">
        <S.LeftCol>
          <S.Title>{t('landingV2.sectionAppBioAtlas.title')}</S.Title>
          <S.DownloadRow>
            <S.DownloadText>
              {t('landingV2.sectionAppBioAtlas.downloadText')}
            </S.DownloadText>
            <S.StoreLogos>
              <ImageNext
                src={`${process.env.CDN_URL}/public/landingpagev2/images/apple-store-logo.png`}
                alt="Apple Store"
                width={40}
                height={40}
              />
              <ImageNext
                src={`${process.env.CDN_URL}/public/landingpagev2/images/play-store-logo.png`}
                alt="Play Store"
                width={40}
                height={40}
              />
            </S.StoreLogos>
          </S.DownloadRow>
          <S.AppButton>{t('landingV2.sectionAppBioAtlas.button')}</S.AppButton>
        </S.LeftCol>
        <S.RightCol>
          <S.TabletImg>
            <ImageNext
              src={`${process.env.CDN_URL}/public/landingpagev2/images/tablet.png`}
              alt="App BioAtlas no tablet"
              width={428}
              height={295}
              priority
            />
          </S.TabletImg>
          <S.PhoneImg>
            <ImageNext
              src={`${process.env.CDN_URL}/public/landingpagev2/images/phone.png`}
              alt="App BioAtlas no celular"
              width={169}
              height={223}
              priority
            />
          </S.PhoneImg>
        </S.RightCol>
      </S.Container>
    </S.Section>
  )
}

export default SectionAppBioAtlas
